import { Box, Button, Grid, IconButton, ImageList, ImageListItem, ImageListItemBar, Skeleton, Typography, useMediaQuery, useTheme } from '@mui/material'
import React, { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { getNews } from '../../feature/api/news'
import InfiniteScroll from 'react-infinite-scroll-component';
import { useNavigate } from 'react-router';
import { Masonry } from '@mui/lab';

const News = () => {
    const dispatch = useDispatch();
    const navigate = useNavigate()
    const theme = useTheme()
    const phone = useMediaQuery(theme.breakpoints.between(280,830))
    const news = useSelector(state => state.news.news)
    const isLoadingNews = useSelector(state => state.news.isLoadingNews)
    const [counters,setCounters] = useState(2)
    const [arrayNews,setArrayNews] = useState([])
    const [loading,setLoading] = useState(true)
    useEffect(()=>{
  
      if(news?.length > 0){
       
        
        setArrayNews([...arrayNews,...news])
      }else{
        setArrayNews([...arrayNews])
      }
  
    
    },[news])

  const fetchMoreData = ()=>{
    setTimeout(()=>{
      dispatch(getNews(counters))
    },1000)
      setCounters(counters + 1) 
  }


    useEffect(() => {
      let method = true
      if(method){
        dispatch(getNews(1))
        setTimeout(()=>{
          setLoading(false)
        },3000)

      }

     return ()=> method=false
    }, [])
    
  return (
    <Grid container width={"100%"}  display={"flex"} justifyContent={"center"} p="10px">
      
      {loading ? 
        <ImageList
        sx={{ width: '100%',height:'100%' }}
        variant="masonry" cols={phone ? 1:3} gap={8}
      
      >
            
              <ImageListItem >
                <Skeleton sx={{
                  height:400
                }} animation="wave" variant="rectangular" />
                <ImageListItemBar
                       
                
                      title={  <Skeleton
                        animation="wave"
                        height={10}
                        width="80%"
                        style={{ marginBottom: 6 }}
                      />}
                      subtitle={  <Skeleton
                        animation="wave"
                        height={10}
                        width="80%"
                        style={{ marginBottom: 6 }}
                      />}
                  
                    />

               

              </ImageListItem>
            
              <ImageListItem >
                <Skeleton sx={{
                  height:400
                }} animation="wave" variant="rectangular" />
                <ImageListItemBar
                       
                
                      title={  <Skeleton
                        animation="wave"
                        height={10}
                        width="80%"
                        style={{ marginBottom: 6 }}
                      />}
                      subtitle={  <Skeleton
                        animation="wave"
                        height={10}
                        width="80%"
                        style={{ marginBottom: 6 }}
                      />}
                  
                    />

               

              </ImageListItem>
            
              <ImageListItem >
                <Skeleton sx={{
                  height:400
                }} animation="wave" variant="rectangular" />
                <ImageListItemBar
                       
                
                      title={  <Skeleton
                        animation="wave"
                        height={10}
                        width="80%"
                        style={{ marginBottom: 6 }}
                      />}
                      subtitle={  <Skeleton
                        animation="wave"
                        height={10}
                        width="80%"
                        style={{ marginBottom: 6 }}
                      />}
                  
                    />

               

              </ImageListItem>


        </ImageList>
      :<InfiniteScroll
           dataLength={arrayNews?.length}
           next={fetchMoreData}
           hasMore={true}
           loader={isLoadingNews&&
            <ImageList
            sx={{ width: '100%',height:'100%' }}
            variant="masonry" cols={phone ? 1:3} gap={8}
          
          >
                
                  <ImageListItem >
                    <Skeleton sx={{
                      height:400
                    }} animation="wave" variant="rectangular" />
                    <ImageListItemBar
                           
                    
                          title={  <Skeleton
                            animation="wave"
                            height={10}
                            width="80%"
                            style={{ marginBottom: 6 }}
                          />}
                          subtitle={  <Skeleton
                            animation="wave"
                            height={10}
                            width="80%"
                            style={{ marginBottom: 6 }}
                          />}
                      
                        />

                   

                  </ImageListItem>


            </ImageList>
           }
           scrollableTarget="scrollableDiv"
           style={{
              width:'100%'
           }}
         > 
      
            <ImageList
            sx={{ width: '100%',height:'100%' }}
            variant="masonry" cols={phone ? 1:3} gap={8}
          
          >
              {arrayNews?.map((item,index)=> 
                
                  <ImageListItem key={index}>
                    <img 
                      src={`${item.Image}?w=248&fit=crop&auto=format`} 
                      alt={item.Title} 
                      width="100%"  
                      onClick={()=>{
                        navigate(`/home/new/${item.Id}`)
                        window.scrollTo(0, 0);
                        }}
                      
                      srcSet={`${item.Image}?w=248&fit=crop&auto=format&dpr=2 2x`}
                      />
                        <ImageListItemBar
                           onClick={()=>{
                            navigate(`/home/new/${item.Id}`)
                            window.scrollTo(0, 0);
                            }}
                        sx={{'&:hover':{height:!phone &&'100%'}}}
               
                          title={item.Title}
                          subtitle={item.Brif}
                          actionIcon={
                            <IconButton
                              sx={{ color: 'rgba(255, 255, 255, 0.54)' }}
                              aria-label={`info about ${item.title}`}
                              onClick={()=>{
                                navigate(`/home/new/${item.Id}`)
                                window.scrollTo(0, 0);
                                }}
                            >
                                    <Button variant='contained' >بیشتر بخوانید</Button>
                            </IconButton>
                          }
                        />

                   

                  </ImageListItem>

              )}

            </ImageList>

       
         </InfiniteScroll>}
    </Grid>
  )
}

export default News